import React, { useState, useEffect, useCallback } from "react";
import { Container } from "@mui/system";
import Logo from "../../assets/img/logo-reenergisa.png";
import {
    Grid, Card, Box, CardHeader, CardContent, Button, Typography, Tooltip,
    Paper, TextField, Divider, IconButton
} from '@mui/material';
import CustomLoading from "../../components/CustomLoading";
import KeyIcon from '@mui/icons-material/Key';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import DoneIcon from '@mui/icons-material/Done';
import UndoIcon from '@mui/icons-material/Undo';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import storage from "../../services/storage";
import api from "../../services/api";
import './styles.css';

const AlterarSenhaAcessoPage = () => {
    const [showLoading, setShowLoading] = useState(false);
    const [errorText, setErrorText] = useState("");
    const [passwordOld, setPasswordOld] = useState("");
    const [passwordNew, setPasswordNew] = useState("");
    const [passwordNewConfirm, setPasswordNewConfirm] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showPasswordNew, setShowPasswordNew] = useState(false);
    const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
    const [validate, setValidate] = useState(false)

    const handleKeyPress = (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            return true;
        }
    };

    const handleClickShowPassword = (event) => {
        event.preventDefault()
        setShowPassword(!showPassword);
    };

    const handleClickShowPasswordNew = (event) => {
        event.preventDefault()
        setShowPasswordNew(!showPasswordNew);
    };

    const handleClickShowPasswordConfirm = (event) => {
        event.preventDefault()
        setShowPasswordConfirm(!showPasswordConfirm);
    };

    const mouseDownShowPassword = (event) => {
        event.preventDefault();
    };

    const mouseDownShowPasswordNew = (event) => {
        event.preventDefault();
    };

    const mouseDownShowPasswordConfirm = (event) => {
        event.preventDefault();
    };

    function handlerClickChangePassword(event) {
        event.preventDefault();
        setShowLoading(true);

        let email = storage.getTerceiroEmail();

        let requestBody = {
            primeiro_acesso: true,
            email: email,
            password_old: passwordOld,
            password_new: passwordNew
        };

        if (!checkPassword()) {
            setErrorText("Verifique as informações de entrada!");
            setShowLoading(false);
            return;
        }

        api.initExternalUpdatePass.post('/alterar', requestBody).then((response) => {
            if (response.data.code !== undefined && response.data.code === 200) {
                window.location = 'pages/home';
            } else {
                setErrorText(response.data.message);
            }

            setShowLoading(false);
        })
            .catch(() => {
                setErrorText("Verifique as informações de entrada!");
                setShowLoading(false);
            });
    }

    const checkPassword = useCallback(() => {
        if (passwordNew !== "" && passwordNewConfirm !== "") {
            setErrorText("");
            if (passwordNew !== passwordNewConfirm) {
                setErrorText("Nova senha e confirmação não são iguais!");
                return false;
            }

            let r = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[$*&@#!%;,.?])(?=.*[0-9])(?:([0-9a-zA-Z$*&@#!%;,.?])(?!\1)){8,}$/;
            let test = r.test(passwordNew);

            if (!test) {
                setErrorText("Nova senha digitada não confere com as políticas de senha!");
            }

            return test;
        }

        return false;
    }, [passwordNew, passwordNewConfirm]);

    useEffect(() => {
        let valid = checkPassword();
        setValidate(valid);
    }, [checkPassword])

    return (
        <>
            <CustomLoading show={showLoading} />

            <Container maxWidth="sm" className="text-center margin-top-50px">
                <Grid container direction="row" justifyContent="center" alignItems="center" mt={2} className="text-center padding-30px-15px">
                    <Grid item lg={8} md={8} sm={6} className="text-center">
                        <Card elevation={3} className="text-center padding-20px">
                            <Box>
                                <img src={Logo} className="width-100px" alt="logo" />
                            </Box>
                            <CardHeader title="EnergisaDash" subheader="Dashboards." />

                            <CardContent>
                                <Grid container className="margin-top-25px text-left">
                                    <Grid item lg={12} sm={12}>
                                        <Typography className="font-size-9-pt color-disabled">
                                            Atualização de senha de acesso ao EnergisaDash.
                                        </Typography>
                                    </Grid>

                                    <Paper
                                        component="form"
                                        sx={{ marginTop: '10px', p: '2px 4px', display: 'flex', alignItems: 'center', width: 400 }}
                                    >
                                        <LockOpenIcon color="primary" />
                                        <Divider sx={{ height: 28, m: 1 }} orientation="vertical" />
                                        <TextField
                                            name="input-password-old"
                                            sx={{ ml: 1, flex: 1 }}
                                            placeholder="Senha atual"
                                            inputProps={{ 'aria-label': 'Senha atual' }}
                                            value={passwordOld}
                                            onChange={(e) => setPasswordOld(e.target.value)}
                                            type={showPassword ? 'text' : 'password'}
                                            onKeyPress={(e) => handleKeyPress(e)}
                                            variant="standard"
                                            error={errorText !== ""}
                                        />
                                        <Divider sx={{ height: 28, m: 1 }} orientation="vertical" />
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPassword}
                                            onMouseDown={mouseDownShowPassword}
                                        >
                                            {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                                        </IconButton>

                                    </Paper>

                                    <Paper
                                        component="form"
                                        sx={{ marginTop: '10px', p: '2px 4px', display: 'flex', alignItems: 'center', width: 400 }}
                                    >
                                        <KeyIcon color="primary" />
                                        <Divider sx={{ height: 28, m: 1 }} orientation="vertical" />
                                        <TextField
                                            name="input-password-new"
                                            sx={{ ml: 1, flex: 1 }}
                                            placeholder="Nova senha"
                                            inputProps={{ 'aria-label': 'Nova senha' }}
                                            type={showPasswordNew ? 'text' : 'password'}
                                            onKeyPress={(e) => handleKeyPress(e)}
                                            value={passwordNew}
                                            onChange={(e) => setPasswordNew(e.target.value)}
                                            variant="standard"
                                            error={errorText !== ""}
                                        />
                                        <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPasswordNew}
                                            onMouseDown={mouseDownShowPasswordNew}
                                        >
                                            {showPasswordNew ? <VisibilityIcon /> : <VisibilityOffIcon />}
                                        </IconButton>
                                    </Paper>

                                    <Paper
                                        component="form"
                                        sx={{ marginTop: '10px', p: '2px 4px', display: 'flex', alignItems: 'center', width: 400 }}
                                    >
                                        <KeyIcon color="primary" />
                                        <Divider sx={{ height: 28, m: 1 }} orientation="vertical" />
                                        <TextField
                                            name="input-cod-auth"
                                            sx={{ ml: 1, flex: 1 }}
                                            placeholder="Confirmação"
                                            inputProps={{ 'aria-label': 'Confirmação' }}
                                            type={showPasswordConfirm ? 'text' : 'password'}
                                            onKeyPress={(e) => handleKeyPress(e)}
                                            value={passwordNewConfirm}
                                            onChange={(e) => setPasswordNewConfirm(e.target.value)}
                                            variant="standard"
                                            error={errorText !== ""}
                                        />
                                        <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPasswordConfirm}
                                            onMouseDown={mouseDownShowPasswordConfirm}
                                        >
                                            {showPasswordConfirm ? <VisibilityIcon /> : <VisibilityOffIcon />}
                                        </IconButton>

                                    </Paper>

                                    <Grid item lg={12} sm={12} className="margin-top-10px">
                                        <Typography className="margin-top-10px font-size-9-pt policy-invalid">
                                            {errorText}
                                        </Typography>
                                    </Grid>

                                    <Grid item lg={12} sm={12} className="text-right margin-top-10px">
                                        <Tooltip title={"Confirmar"}>
                                            <span>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    sx={{ p: '10px' }}
                                                    aria-label="done"
                                                    startIcon={<DoneIcon />}
                                                    onClick={(e) => handlerClickChangePassword(e)}
                                                    disabled={!validate}
                                                >
                                                    Confirmar
                                                </Button>
                                            </span>
                                        </Tooltip>
                                    </Grid>

                                    <Grid item lg={12} sm={12}>
                                        <Typography className="margin-top-10px font-size-9-pt color-disabled">
                                            Políticas de senha:<br />
                                        </Typography>
                                        <ul>
                                            <li id='senha-policy-1'>
                                                <Typography className="font-size-9-pt color-disabled">Mínimo 8 caracteres;</Typography>
                                            </li>
                                            <li id='senha-policy-2'>
                                                <Typography className="font-size-9-pt color-disabled">Mínimo 1 caractere de letra maiúscula;</Typography>
                                            </li>
                                            <li id='senha-policy-3'>
                                                <Typography className="font-size-9-pt color-disabled">Mínimo 1 caractere de letra minúscula;</Typography>
                                            </li>
                                            <li id='senha-policy-4'>
                                                <Typography className="font-size-9-pt color-disabled">Mínimo 1 caractere de número;</Typography>
                                            </li>
                                            <li id='senha-policy-5'>
                                                <Typography className="font-size-9-pt color-disabled">Mínimo 1 caractere especial;</Typography>
                                            </li>
                                        </ul>
                                        <Typography className="font-size-9-pt color-disabled">
                                            Você precisa atualizar sua senha de acesso seguindo as políticas de segurança.
                                        </Typography>
                                    </Grid>

                                    <Grid item lg={12} sm={12} className="text-right">
                                        <Button variant="outlined" startIcon={<UndoIcon />} onClick={() => window.location = '/login-terceiros'}>
                                            Voltar
                                        </Button>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>

                        <Grid container mt={1}>
                            <Grid item lg={12} sm={6} className="text-right padding-10px">
                                <Button className="color-disabled">Ajuda</Button>
                                <Button className="color-disabled">Privacidade</Button>
                                <Button className="color-disabled">Termos</Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Container >

        </>
    )
}

export default AlterarSenhaAcessoPage;